var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3823 47.2549L31.855 38.0912L24.0005 23.2549L16.1459 37.2185L3.92773 47.2549H19.2005H45.3823Z",
    fill: "#B0BABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.929688L0 48.9297H48L24 0.929688ZM24 25.9304L29.5376 36.5735H18.4624L24 25.9304ZM22.5938 22.4073L14.9957 37.0104L6.17782 42.9915L22.5938 10.1596V22.4073ZM16.4382 39.6625H31.5618L40.6701 45.8406H7.33L16.4382 39.6625ZM33.0043 37.0104L25.4062 22.4073V10.1596L41.8222 42.9915L33.0043 37.0104Z",
    fill: "#6E7C87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/Silver.e5e359135c7a1d8a585aedbc38e4f0de.svg";
export { ForwardRef as ReactComponent };